import React, { memo } from 'react'
import classes from "./DefaultLabel.module.css"

const DefaultLabel = ({ label, required = false }) => {
    return (
        <label className={`${classes.defLabel}`}>
            {label}
            {required && <span className={classes.requiredMark}>*</span>}
        </label>
    )
}

export default memo(DefaultLabel)
